import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { asyncScheduler, filter, fromEvent, throttleTime } from 'rxjs';

@Component({
  selector: 'app-slide-show-swiper',
  templateUrl: './slide-show-swiper.component.html',
  styleUrl: './slide-show-swiper.component.scss'
})
export class SlideShowSwiperComponent implements OnInit {

  public swiperEl = null;
  @ViewChild('swiper')
  set swiperRef(swiperRef: ElementRef) {
    this._swiperRef = swiperRef;
    if(swiperRef){
      switch (this.configType) {
        case 0:
        this.swiperEl =  new window['Swiper'](this._swiperRef.nativeElement, this.configArrImg);
          break;
        case 1:
          this.swiperEl = new window['Swiper'](this._swiperRef.nativeElement, this.configOneImg);
          break;
        default:
          this.swiperEl =  window['Swiper'](this._swiperRef.nativeElement, this.configOneImg);
          break;
      }
    }
  };
  get swiperRef(): ElementRef {
    return this._swiperRef;
  }

  @Input()optionImages:[] = [];
  @Input()configType:number = 1;

  private _swiperRef = null;
  public imgArr = [];

  public configOneImg:any = {
    autoHeight: true,
    allowTouchMove: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    slidesOffsetAfter:200,
    centerInsufficientSlides: true,
    grabCursor: false,
    centeredSlides: true,
    centeredSlidesBounds: true
  };

  public configArrImg:any = {
    autoplay:{ delay: 2000 },
    autoHeight: true,
    allowTouchMove: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    slidesOffsetAfter:200,
    centerInsufficientSlides: true,
    loop: true,
    grabCursor: false,
    centeredSlides: true,
    centeredSlidesBounds: true
  };

  constructor() {
    fromEvent(window, 'resize').pipe(
      filter(() => this.swiperEl !== null),
      throttleTime(250, asyncScheduler, {
        leading: true,
        trailing: true
      }),
      takeUntilDestroyed()
    ).subscribe(() => {
      this.swiperEl.updateSize();
    });
  }

  ngOnInit(): void {
    this.getImageArr(this.optionImages);
  }


  getImageArr(arr){
    if(arr.length <= 3 && this.configType == 0){
      this.imgArr = [...arr,...arr,...arr];
    }else{
      this.imgArr = arr;
    }
  }

}
